import {
  Box, Button, Grid, Typography,
} from '@mui/material';
import HeaderTags from '../common/HeaderTags';
import i18n from '../common/i18n';
import { isMobileOperatingSystem, useIsMobile } from '../../utils/functionUtils';
import electroDesktopImg from '../../assests/images/electro/electro_desktop.png';
import electroMobileImg from '../../assests/images/electro/electro_mobile.png';
import LandingSteps from '../LandingSteps';
import LandingRequirements from '../LandingRequirements';
import LandingBrandAndModels from '../LandingBrandAndModels';
import LandingChooseUs from '../LandingChooseUs';
import LandingFaqs from '../LandingFaqs';

const LandingElectro = () => {
  const ctaBanner = () => {
    window.open('https://onboarding.credicuotas.com.ar/', '_blank');
  };
  const isMobile = useIsMobile();

  return (
    <>
      <HeaderTags title={i18n.ElectroLanding.title} content={i18n.ElectroLanding.description} scriptMarkUpSchema />

      {/* BANNER */}
      <Box className="landing-banner" mt={isMobile ? 2 : 7} pt={!isMobile ? 2 : 0}>
        <Grid container display="flex" flexDirection="row" alignItems="center">
          {/* BANNER DESKTOP */}
          {!isMobileOperatingSystem() ? (
            <>
              <Grid item md={8}>
                <Box className="landing-banner-div" mt={2} mb={2}>
                  <Typography variant="h1">{i18n.ElectroLanding.title}</Typography>
                  <Typography>{i18n.ElectroLanding.description}</Typography>
                  <Button
                    onClick={ctaBanner}
                    variant="contained"
                    sx={{ marginTop: '20px' }}
                  >
                    {i18n.ElectroLanding.ctaBanner}
                  </Button>
                </Box>
              </Grid>
              <Grid item md={4}>
                <img src={electroDesktopImg} alt="ELECTRO" />
              </Grid>
            </>
          ) : (
            // BANNER MOBILE
            <Grid item md={8}>
              <Box className="landing-banner-div">
                <Typography variant="h1">{i18n.ElectroLanding.title}</Typography>
                <Typography>{i18n.ElectroLanding.description}</Typography>
                <Button
                  onClick={ctaBanner}
                  variant="contained"
                  sx={{ marginTop: '50px' }}
                >
                  {i18n.ElectroLanding.ctaBanner}
                </Button>
                <img src={electroMobileImg} alt="ELECTRO" style={{ maxWidth: '40%' }} />
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>

      <Box className="body">
        {/* SECCION STEPS PARA COMPRAR ELECTRO */}
        <Box mt={5} />
        <LandingSteps title={i18n.ElectroLanding.howToTitle} steps={i18n.ElectroLanding.howToSteps} />

        {/* SECCION REQUISITOS */}
        <LandingRequirements
          title={i18n.ElectroLanding.requirementsTitle}
          requirements={i18n.ElectroLanding.requirements}
        />

        {/* SECCION MARCAS Y MODELOS */}
        <Box mt={5} />
        <LandingBrandAndModels
          title={i18n.ElectroLanding.brandsTitle}
          description={i18n.ElectroLanding.brandsDescription}
          brands="/images/electro/models_desktop.png"
          brandsMobile="/images/electro/models_mobile.png"
        />

        {/* SECCION ELEGINOS */}
        <LandingChooseUs
          titles={i18n.ElectroLanding.chooseUsTitle}
          messages={i18n.ElectroLanding.chooseUsMessages}
        />

        {/* SECCION FAQs */}
        <LandingFaqs faqs={i18n.ElectroLanding.faqs} />
      </Box>
      <Box mb={5} className="landing-footer">
        <Typography>{i18n.ElectroLanding.footer}</Typography>
      </Box>
    </>
  );
};

export default LandingElectro;
